module.exports = __webpack_public_path__ + "img/prol_laterale_sx.4d607279.png";